var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { OutskirtBuildingWithLevel, } from "../outskirts/OutskirtBuildingWithLevel";
var OutskirtBuildingLibrary = /** @class */ (function (_super) {
    __extends(OutskirtBuildingLibrary, _super);
    function OutskirtBuildingLibrary() {
        var _this = _super.call(this, IdOutskirtBuildings.Library) || this;
        _this.update = function (props) {
            _super.prototype.updateDisplay.call(_this, props);
            _this.baseUpdate(props, undefined, false);
        };
        return _this;
    }
    return OutskirtBuildingLibrary;
}(OutskirtBuildingWithLevel));
export { OutskirtBuildingLibrary };



//////////////////
// WEBPACK FOOTER
// ./src/features/library/OutskirtBuildingLibrary.ts
// module id = 2175
// module chunks = 3